
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import WithTooltip from 'components/WithTooltip'

export default class Label extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
    line: PropTypes.bool,
    dashed: PropTypes.bool,
    ring: PropTypes.bool,
    onClick: PropTypes.func,
    tooltip: PropTypes.node
  }

  render() {
    const {color, line, dashed, ring, className, tooltip, onClick} = this.props
    const labelClassName = classnames('label', className, {
      [`is-${color}`]: color,
      'is-line': line,
      'is-dashed': dashed,
      'is-ring': ring,
      'is-clickable': !!onClick
    })

    return (
      <WithTooltip title={tooltip} style='blue'>
        <div className={labelClassName} onClick={onClick}>
          {this.props.children}
        </div>
      </WithTooltip>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Label/index.js